

import React from "react";
import { Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage/HomePage";
import BookingPage from "./pages/BookingPage/BookingPage";
import MenuPage from "./pages/MenuPage/MenuPage";
import Login from "./pages/Login/Login";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import ResetPasswordConfirm from "./pages/ResetPassword/ResetPasswordConfirm";
import Register from "./pages/Register/Register";
import ConfirmedBooking from "./pages/ConfirmedBooking/ConfirmedBooking";
import OrderOnlinePage from "./pages/OrderOnlinePage/OrderOnlinePage";
import CartPage from './pages/CartPage/CartPage';
import ProfilePage from "./pages/ProfilePage";
import ManageReservationPage from "./pages/ManageReservationPage";
import OrderConfirmation from "./pages/OrderConfirmation";
import AboutPage from "./pages/AboutPage/AboutPage";
import ReservationHistory from "./pages/ReservationHistory/ReservationHistory";
import OrderHistory from "./pages/OrderHistory/OrderHistory";
import CustomerReviewHistory from "./pages/CustomerReviewHistory/CustomerReviewHistory";
import Layout from "./components/Layout/Layout";
import BareLayout from "./components/Layout/BareLayout";
import ChatbotOrderPage from "./pages/ChatbotOrderPage";






function Main() {
  return (
    // <Layout>
    //   <Routes>
    //     <Route path="/" element={<HomePage />} />
    //     <Route path="/about" element={<AboutPage />} />
    //     <Route path="/reservations" element={<BookingPage />} />
    //     <Route path="/menu" element={<MenuPage />} />
    //     <Route path="/order-online" element={<OrderOnlinePage />} />
    //     <Route path="/login" element={<Login />} />
    //     <Route path="/reset-password" element={<ResetPassword />} />
    //     <Route path="/reset-password/:uid/:token" element={<ResetPasswordConfirm />} />
    //     <Route path="/register" element={<Register />} />
    //     <Route path="/profile" element={<ProfilePage />} />
    //     <Route path="/cart" element={<CartPage />} />
    //     <Route path="/confirmation" element={<ConfirmedBooking />} />
    //     <Route path="/manage-reservation/:ref" element={<ManageReservationPage />} />
    //     <Route path="/order-confirmation" element={<OrderConfirmation />} />
    //     <Route path="/my-reservations" element={<ReservationHistory />} />
    //     <Route path="/my-orders" element={<OrderHistory />} />
    //     <Route path="/my-reviews" element={<CustomerReviewHistory />} />
    //     <Route path="/bot-orders" element={<ChatbotOrderPage />} />
    //   </Routes>
    // </Layout>

    <Routes>
      {/* Special route that uses BareLayout and skips Layout */}
      <Route path="/bot-orders" element={
        <BareLayout>
          <ChatbotOrderPage />
        </BareLayout>
      } />

      {/* All other routes wrapped with Layout */}
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/reservations" element={<BookingPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/order-online" element={<OrderOnlinePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/reset-password/:uid/:token" element={<ResetPasswordConfirm />} />
        <Route path="/register" element={<Register />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/confirmation" element={<ConfirmedBooking />} />
        <Route path="/manage-reservation/:ref" element={<ManageReservationPage />} />
        <Route path="/order-confirmation" element={<OrderConfirmation />} />
        <Route path="/my-reservations" element={<ReservationHistory />} />
        <Route path="/my-orders" element={<OrderHistory />} />
        <Route path="/my-reviews" element={<CustomerReviewHistory />} />
      </Route>
    </Routes>

  );
}

export default Main;

